import { Check, Ruler } from "lucide-react"
import { Button, ButtonSize } from "shared-web/components/base/control/Button"
import { Icon, IconSizes } from "shared-web/components/Icon"

import { classNames } from "lib/classNames"

interface TallySlotProps {
  summary: string
  isCompact: boolean
  canAdd: boolean
  onClick?: () => void
  className?: string
  receivingSummary?: string
  title?: string
}

export function TallySlot({
  summary,
  isCompact,
  canAdd,
  onClick,
  className,
  receivingSummary,
  title,
}: TallySlotProps) {
  const isDifferent = !!receivingSummary && receivingSummary !== summary

  if (!summary && !canAdd) {
    return null
  }
  if (!onClick) {
    return (
      <div
        className={classNames(
          "color-default text-body flex items-center gap-x-1",
          className
        )}
      >
        <Icon icon={Ruler} size={IconSizes.Small} aria-hidden="true" />
        <span className="max-w-64 truncate">{summary}</span>
      </div>
    )
  }

  return (
    <Button
      className={className}
      mode="secondary"
      size={isCompact ? ButtonSize.ExtraSmall : ButtonSize.Small}
      leftIcon={Ruler}
      onClick={onClick}
      title={title}
    >
      <span className="inline-flex min-w-0 items-center gap-x-2">
        {isDifferent && (
          <>
            <span className="block min-w-0 max-w-64 truncate">
              {receivingSummary}
            </span>
            <span className="text-v2-foreground-default-weaker text-body shrink-0">
              of
            </span>
          </>
        )}

        <span
          className={classNames(
            "block min-w-0 max-w-64 truncate",
            isDifferent && "text-v2-foreground-default-weaker text-body"
          )}
        >
          {summary || "Add tally"}
        </span>

        {!!receivingSummary && receivingSummary === summary && (
          <Icon
            icon={Check}
            size={IconSizes.ExtraSmall}
            className="shrink-0"
            aria-hidden="true"
          />
        )}
      </span>
    </Button>
  )
}
